(function () {
  'use strict';

  /* ---------- Card pack picker (10-pack / 40-pack / etc.) ---------- */
  document.querySelectorAll('[data-l2-pack-picker]').forEach(function (picker) {
    var hiddenInput = picker.querySelector('[data-l2-selected-variant]');
    var options = picker.querySelectorAll('[data-l2-pack-option]');

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        options.forEach(function (b) { b.classList.remove('l2-pack--selected'); });
        btn.classList.add('l2-pack--selected');
        hiddenInput.value = btn.getAttribute('data-variant-id');

        /* Update the SKU line to match the selected variant, if this
           button carries a data-sku attribute (currently only used by
           the USA grid section - harmless no-op everywhere else, since
           other sections' buttons never have this attribute). */
        var newSku = btn.getAttribute('data-sku');
        if (newSku) {
          var card = picker.closest('.l2-card');
          var skuDisplay = card ? card.querySelector('.l2-card__sku') : null;
          if (skuDisplay) {
            skuDisplay.textContent = 'SKU: ' + newSku;
          }
        }
      });
    });
  });

  /* ---------- Add to Cart (card grid) ---------- */
  document.querySelectorAll('[data-l2-add-to-cart]').forEach(function (button) {
    button.addEventListener('click', function () {
      var card = button.closest('.l2-card');
      var hiddenInput = card.querySelector('[data-l2-selected-variant]');
      if (!hiddenInput || !hiddenInput.value) return;

      addToCart(hiddenInput.value, 1, button);
    });
  });

  /* ---------- Contractor pack: dropdown swaps price/savings/variant ---------- */
  document.querySelectorAll('[data-l2-contractor]').forEach(function (block) {
    var select = block.querySelector('[data-l2-contractor-select]');
    var priceEl = block.querySelector('[data-l2-contractor-price]');
    var perBulbEl = block.querySelector('[data-l2-contractor-per-bulb]');
    var saveEl = block.querySelector('[data-l2-contractor-save]');
    var addLabel = block.querySelector('[data-l2-contractor-add-label]');
    var addButton = block.querySelector('[data-l2-contractor-add-to-cart]');
    var subheadEl = block.parentElement.querySelector('[data-l2-contractor-subhead]');
    var chipsEl = block.parentElement.querySelector('[data-l2-contractor-chips]');

    function updateFromSelection() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      priceEl.textContent = opt.getAttribute('data-price') || '';
      perBulbEl.textContent = opt.getAttribute('data-per-bulb') || '';
      var save = opt.getAttribute('data-save');
      if (save && parseInt(save, 10) > 0) {
        saveEl.textContent = 'Save ' + save + '%';
        saveEl.style.display = '';
      } else {
        saveEl.textContent = '';
        saveEl.style.display = 'none';
      }
      var qty = opt.getAttribute('data-qty');
      if (addLabel && qty) {
        addLabel.textContent = 'ADD ' + qty + ' TO CART';
      }
      if (subheadEl) {
        subheadEl.textContent = opt.getAttribute('data-subhead') || '';
      }
      if (chipsEl) {
        var chips = (opt.getAttribute('data-chips') || '').split('|').filter(Boolean);
        chipsEl.innerHTML = chips.map(function (c) { return '<li>' + c + '</li>'; }).join('');
      }
    }

    if (select) {
      select.addEventListener('change', updateFromSelection);
      updateFromSelection();
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        addToCart(opt.value, 1, addButton);
      });
    }
  });

  /* ---------- Shared Cart AJAX call ---------- */
  function addToCart(variantId, quantity, triggerButton) {
    var originalText = triggerButton ? triggerButton.textContent : null;
    if (triggerButton) {
      triggerButton.disabled = true;
      triggerButton.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        if (triggerButton) {
          triggerButton.textContent = 'Added!';
          setTimeout(function () {
            triggerButton.textContent = originalText;
            triggerButton.disabled = false;
          }, 1200);
        }
        // Refresh cart count / drawer if the theme exposes one.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function (err) {
        console.error(err);
        if (triggerButton) {
          triggerButton.textContent = 'Error — try again';
          triggerButton.disabled = false;
        }
      });
  }
})();
